export default {
    public: {
        ENVIRONMENT: 'opt',
        API_URL: 'https://api-cf-kr.codepresso.io',
        CODE_RUN_BRIDGE_API_URL: 'https://coderun-bridge-kr.codepresso.io',
        CODE_RUN_BRIDGE_SOCKET_URL: 'wss://coderun-bridge-kr.codepresso.io/global',
        SOCIAL_REDIRECT_URL: 'https://kr.codepresso.io/auth/user/social',

        CODERUN_DOMAIN: 'https://coderun-opt.codepresso.io',

        MIXPANEL_TOKEN: "c20f725df035b82e467f791eeade1695",

        AWS_IDENTITY_POLL_ID: "ap-northeast-2:216a7f2c-317e-440e-bd65-785475927845",
        LEARNING_DEFAULT_DIRECTORY_BUCKET: "codepresso-global-contents-multi-file",
        LEARNING_DEFAULT_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://contents-multifile.codepresso.io",
        LEARNING_USER_DIRECTORY_BUCKET: "codepresso-global-user-multi-file",
        USER_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://user-file.codepresso.io",
        LEARNING_USER_ANALYSIS_DIRECTORY_BUCKET: "codepresso-global-analysis-report-opt",
        LEARNING_USER_ANALYSIS_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://static-analysis-reports-opt.codepresso.io",

        COOKIE_DOMAIN: 'kr.codepresso.io',
        // onboarding/survey SDK·자산을 로드할 S3 prefix 도메인 (s3://codepresso-onboarding/{값}/). onboarding upload-s3.mjs 의 DOMAIN 과 일치해야 한다.
        SDK_ASSET_DOMAIN: 'codepresso.io',
        MAIN_URL: 'https://kr.codepresso.io/',
        BUILD_VERSION: 'v2.19.0',
        BUILD_COMMIT: 'unknown',
        BUILD_TIME: '',
        DESKTOP_APP_NAME: 'Proctive',
        DESKTOP_APP_VERSION: '1.8.0',
        PRODUCT_FRUITS_WORKSPACE_CODE: '0gIxreipuStmDVcj',
        ADAPTIVE_LECTURE_URL: 'https://adaptive-lecture.codepresso.io/track-level',

        STRIPE_PUBLISHABLE_KEY: 'pk_live_51QweEpG6kTnBbSqgyH84nhDtYkkeDMvnBagIR6qdqWG5FL7inhQzG0YwUgxAs0l3D8GLTYmgCWGnSR07Bs79vd8H00EoEub2NF',
        TOSS_CLIENT_KEY: 'live_ck_DnyRpQWGrNLqAXe5Nqp73Kwv1M9E',
        TOSS_PAYMENT_CLIENT_KEY: 'live_ck_E92LAa5PVbvEXLLkmnJeV7YmpXyJ',
    }
};